import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Style.
 */

export const StyledButtonGroupDivider = styled.div`
  border-left: 1px solid ${(p) => p.theme.greys.shade40};
  width: 0px;
  height: 30px;
  margin-left: 6px;
`;

/*
 * Component.
 */

export const ButtonGroupDivider: FC = () => <StyledButtonGroupDivider />;
